module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kSh1U"))).then(() => module.bundle.root('dJXJK'));